import React, { useEffect, useState } from "react";
import Particles, { initParticlesEngine } from "@tsparticles/react";
import { loadSlim } from "@tsparticles/slim";

const ParticlesBackground = () => {
    const [init, setInit] = useState(false);

    useEffect(() => {
        initParticlesEngine(async (engine) => {
            await loadSlim(engine);
        }).then(() => {
            setInit(true);
        });
    }, []);

    const particlesLoaded = (container) => {
        console.log("Particles loaded", container);
    };

    const options = {
        background: {
            color: { value: "transparent" },
        },
        fpsLimit: 120,
        fullScreen: false,
        interactivity: {
            events: {
                onClick: { enable: true, mode: "push" },
                onHover: {
                    enable: true,
                    mode: "grab",
                    parallax: { enable: true, force: 60, smooth: 10 },
                },
                resize: true,
            },
            modes: {
                push: { quantity: 3 },
                grab: { distance: 200, links: { opacity: 0.5 } },
                repulse: { distance: 80, duration: 0.4 },
            },
        },
        particles: {
            color: { value: ["#07FAEE", "#4A2FBD", "#36AAA4", "#AA367C"] },
            links: {
                color: "random",
                distance: 150,
                enable: true,
                opacity: 0.25,
                width: 1.5,
            },
            move: {
                direction: "none",
                enable: true,
                outModes: { default: "bounce" },
                random: true,
                speed: 0.8,
                straight: false,
                attract: { enable: true, rotateX: 600, rotateY: 1200 },
            },
            number: {
                density: { enable: true, area: 600 },
                value: 100,
            },
            opacity: {
                value: { min: 0.3, max: 0.8 },
                animation: { enable: true, speed: 0.5, sync: false },
            },
            shape: { type: ["circle", "triangle"] },
            size: {
                value: { min: 1, max: 5 },
                animation: { enable: true, speed: 2, sync: false },
            },
            twinkle: {
                particles: {
                    enable: true,
                    frequency: 0.05,
                    opacity: 0.8,
                },
            },
        },
        detectRetina: true,
    };

    if (init) {
        return (
            <div style={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100%", zIndex: -1 }}>
                <Particles
                    id="tsparticles"
                    particlesLoaded={particlesLoaded}
                    options={options}
                />
            </div>
        );
    }

    return null;
};

export default React.memo(ParticlesBackground);
